import _ from 'lodash';
import React from 'react';
import { testStatusesOta, getTestResultTitle } from 'helpers/RequestTestsHelper';

const FilterOptionsOta = () => {
  return _.map(testStatusesOta, id => {
    const title = getTestResultTitle(id).toLowerCase();
    return (
      <option value={id} key={id}>
        {title}
      </option>
    );
  });
};

export default FilterOptionsOta;
